import { OnboardingKeys } from './onboarding-state/onboarding-constants';
import { ContextualInviteNudgeOnboardingKeys } from './onboarding-state/onboarding-contextual-invite-nudge';
import { EditorOnboardingKeys } from './onboarding-state/onboarding-editor-constants';
import { OptionalNthUserGuidedTourOnboardingKeys } from './onboarding-state/onboarding-optional-nth-user-guided-tour-constants';
import { FeedOnboardingKeys } from './onboarding-state/onboarding-feed-constants';
import { HomeTakeoverOnboardingKeys } from './onboarding-state/onboarding-home-takeover-constants';
import { InsightsOnboardingKeys } from './onboarding-state/onboarding-insights-constants';
import { LandInSpampleSpaceOnboardingKeys } from './onboarding-state/onboarding-land-in-sample-space';
import { LiveDocsOnboardingKeys } from './onboarding-state/onboarding-live-docs-constants';
import { SpaceMissionControlOnboardingKeys } from './onboarding-state/onboarding-mission-control-constants';
import { PersonalizedTemplatesOnboardingKeys } from './onboarding-state/onboarding-personalized-templates-constants';
import { PresenceAdminFeedbackSurveyOnboardingKeys } from './onboarding-state/onboarding-presence-admin-feedback-survey';
import { RoleBasedAccessControlOnboardingKeys } from './onboarding-state/onboarding-role-based-access-control';
import { RovoVideoPlayerStateOnboardingKeys } from './onboarding-state/onboarding-rovo-video-player-constants';
import { ShareAndRestrictDialogOnboardingKeys } from './onboarding-state/onboarding-share-and-restrict-dialog-constants';
import { StorageEnforcementOnboardingKeys } from './onboarding-state/storage-enforcement/storage-enforcement-constants';
import { TrialComponentsOnboardingKeys } from './trial-components/trial-components-constants';
import { CreateIntroFirstStepOnboardingStateKeys } from './onboarding-state/onboarding-create-intro-first-step-constants';
import { ExperimentPromptWhiteboardTemplatesOnboardingKeys } from './onboarding-state/experiment-prompt-whiteboard-templates-constants';
import { NotesOnboardingSpotlightKeys } from './onboarding-state/onboarding-notes-constants';
import { NewContentHistoryOnboardingStateKeys } from './onboarding-state/onboarding-new-content-history';
import { AIFCOnboardingKeys } from './onboarding-state/onboarding-afic-onboarding';
import { NthUserHomeOnboardingRevampKeys } from './onboarding-state/onboarding-home-revamp-constants';
import { RovoAwarenessOnboardingKeys } from './onboarding-state/onboarding-rovo-awareness';
import { ExportJiraContextToPageTourKeys } from './onboarding-state/onboarding-export-jira-context-to-page-constants';

export const OnboardingKeysCombined = [
	...StorageEnforcementOnboardingKeys,
	...OnboardingKeys,
	...ContextualInviteNudgeOnboardingKeys,
	...EditorOnboardingKeys,
	...InsightsOnboardingKeys,
	...SpaceMissionControlOnboardingKeys,
	...PresenceAdminFeedbackSurveyOnboardingKeys,
	...RoleBasedAccessControlOnboardingKeys,
	...RovoVideoPlayerStateOnboardingKeys,
	...ShareAndRestrictDialogOnboardingKeys,
	...TrialComponentsOnboardingKeys,
	...PersonalizedTemplatesOnboardingKeys,
	...LiveDocsOnboardingKeys,
	...HomeTakeoverOnboardingKeys,
	...FeedOnboardingKeys,
	...OptionalNthUserGuidedTourOnboardingKeys,
	...LandInSpampleSpaceOnboardingKeys,
	...CreateIntroFirstStepOnboardingStateKeys,
	...ExperimentPromptWhiteboardTemplatesOnboardingKeys,
	...NotesOnboardingSpotlightKeys,
	...NewContentHistoryOnboardingStateKeys,
	...AIFCOnboardingKeys,
	...NthUserHomeOnboardingRevampKeys,
	...RovoAwarenessOnboardingKeys,
	...ExportJiraContextToPageTourKeys,
] as const;

export type OnboardingKeysCombinedType = (typeof OnboardingKeysCombined)[number];
